module.exports = __webpack_public_path__ + "static/media/department.ac683317.svg";